import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { prepareProductUrl } from '../../../services/helpers'
import { missingImageUrl } from '../../../config.json'

export default function UnderlaymentProduct({ name, productUrl, productImage, subheading, shortDescription, thicknessCoverage, colors, unitCount, unit, containerType, sku, coverage, isSoldOnline }) {
   const {
      setCurrentStep,
      setAppHeader,
      setNavState,
      setLinkGoBackTarget,
      productOptionsSelected,
      stepsCompleted,
      setStepsCompleted,
      setProductOptionsSelected,
      // setProductCoverage,
      setProductSelected
   } = useContext(AppContext)

   const iconAngleRight = <FontAwesomeIcon icon={ faAngleRight } color="#00a8d5" />
   const handleProductSelected = () => {
      // Set the selected product as productSelected
       setProductSelected({ name, image: productImage, shortDescription: subheading, description: shortDescription, thicknessCoverage: thicknessCoverage, colors: colors, unitCount: unitCount, unit: unit, containerType: containerType, sku: sku, coverage: coverage, isSoldOnline: isSoldOnline })
      // Update the current step
      setCurrentStep({ step: "underlaymentCoverageDetails" })
      // Update the nav state
      setNavState({ navStep: "UnderlaymentProductSelection" })
      // Set the appHeader for Step state
      setAppHeader("Step 2 of 2")
      // Set the Go Back link
      setLinkGoBackTarget({ link: "underlaymentProductSelection" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Choose an Underlayment")
      setStepsCompleted(stepsCompleted)
      // Add the selected underlayment product to state of App
       productOptionsSelected.productOptions.push(name)
      setProductOptionsSelected({ productOptions: productOptionsSelected.productOptions })
   }

   const imgUrlBase = 'https://cdn.laticrete.com/'
   const imgUrl = productImage ? imgUrlBase + productImage : missingImageUrl
   
   return (    
      <div className="list-item" key={ name }>
         <div className="row p-1">
            <div className="col-xs-12 col-sm-3 hidden-xs">
               <figure className="system-image">
                  <img alt={ name || shortDescription || productImage } src={ imgUrl } className="img-responsive" />
               </figure>
            </div>
            <div className="col-xs-12 col-sm-9">
               <div className="row p-1">
                  <div className="col-xs-12 visible-xs">
                     <figure className="system-image">
                        <img alt={ name || shortDescription || productImage } src={ imgUrl } className="img-responsive" />
                     </figure>
                  </div>
                  <div className="col-xs-12 col-sm-8 col-lg-9">
                     { name && <h4>{ name } { subheading && <small>{ subheading }</small> }</h4> }
                     { shortDescription && <p dangerouslySetInnerHTML={{ __html: shortDescription }}></p> }
                  </div>
                  <div className="col-xs-12 col-sm-4 col-lg-3 hidden-xs">
                     <button className="btn btn-primary btn-block" onClick={() => handleProductSelected()}>SELECT</button>
                  </div>
               </div>
               <div className="row p-1">
                  <div className="col-xs-12">
                  { productUrl && 
                        <a href={ prepareProductUrl(productUrl) } rel="noopener noreferrer" target="_blank">Learn More{ iconAngleRight }</a>
                     }
                     <button className="btn btn-primary btn-block visible-xs" onClick={() => handleProductSelected()}>SELECT</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}



// WEBPACK FOOTER //
// ./src/components/productTypes/underlayment/UnderlaymentProduct.js